import { render, staticRenderFns } from "./MyCompanyPaymentTypesEdit.vue?vue&type=template&id=ed6f8620&"
import script from "./MyCompanyPaymentTypesEdit.vue?vue&type=script&lang=js&"
export * from "./MyCompanyPaymentTypesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports